
<template>
  <div class="container-fluid">
    <div>
      <div class="row card">
        <div class="card-body" id="prof">
          <div class="d-flex align-items-center justify-content-between">
            <div class="search-zone mb-3">
              <div class="input-icon input-icon-right">
                <input
                  v-model="search"
                  type="text"
                  placeholder="Recherche ..."
                  class="w-100 form-control basic_datatable_search_query"
                />
                <span><i class="flaticon2-search-1 icon-md"></i></span>
              </div>
            </div>
            <div>
                <button @click="downloadNhAll" class="btn btn-sm btn-info">Télécharger xls</button>
            </div>
          </div>
          <table ref="table" v-if="NotesLoaded" id="noteTable" class="table">
            <thead style="background-color: #003667; color: white">
              <tr class="text-center">
                <td># Agresso</td>
                <td>Enseignant</td>
                <td>Service annuel</td>
                <td>VH</td>
                <td>HS</td>
                <td>Montant</td>
                <td>Montant Total</td>
                <td>Année</td>
                <td>Etat</td>
                <td>Validation du directeur</td>
                <td>Validation du doyen</td>
                <td>Validation du VPAA</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              <tr
                class="text-center"
                v-for="note in notes"
                :key="`vac_${note.id}`"
              >
                <td>#{{ note.vacataire.agresso }}</td>
                <td>
                  <b>{{ note.vacataire.nom }} {{ note.vacataire.prenom }}</b> <br>
                  <small>{{ note.etablissement.nom }}</small>
                </td>
                <td class="text-left text-nowrap">
                    Ava déch: {{ note.vh_avant_decharge }}<br>
                    <span v-if="note.decharge">Décharge: {{ note.decharge }} <br></span>
                    Apr déch: <b>{{ note.vh_decharge }}</b>
                </td>
                <td class="text-left">
                    VH FI: {{ note.vh_fi }} <br>
                    VH FC: {{ note.vh_fc }}
                </td>
                <td class="text-left">
                    HS FI: {{ note.heures_supp_fi }} <br>
                    HS FC: {{ note.heures_supp_fc }} <br>
                    Total: <b>{{ note.heures_supp_total }}</b>
                </td>
                <td class="text-left">
                  FI: {{ note.montant_total_fi }} <br>
                  FC: {{ note.montant_total_fc }}
                </td>
                <td><b>{{ note.montant_total }}</b> DH</td>
                <td>{{ note.periode_academique }}</td>
                <td style="font-size: 10px" class="text-nowrap">
                  <span
                    style="font-size: 10px"
                    v-show="
                      note.status == 'en cours' ||
                      note.status == 'valide par directeur' ||
                      note.status == 'valide par doyen'
                    "
                    class="label label-xl label-info label-inline ml-3"
                  >
                    En cours
                  </span>
                  <span
                    style="font-size: 10px"
                    v-show="note.status == 'valide par VPAA'"
                    class="label label-xl label-success label-inline ml-3"
                  >
                    Validée
                  </span>
                  <span
                    style="font-size: 10px"
                    v-show="note.status == 'refusee'"
                    class="label label-xl label-danger label-inline ml-3"
                  >
                    Refusée
                  </span>
                  <span
                    style="font-size: 10px"
                    v-show="note.status == '--'"
                    class="label label-xl label-secondary label-inline ml-3"
                  >
                    --
                  </span>
                </td>
                <td>{{ note.date_validation_directeur }}</td>
                <td>{{ note.date_validation_doyen }}</td>
                <td>{{ note.date_validation_VPAA }}</td>
                <td class="d-flex">
                  <!--<button
                    v-if="
                      note.status == 'valide par directeur' &&
                      admin.role.nom == 'DOYEN'
                    "
                    @click="refuse_note_modal(note)"
                    class="btn btn-outline-danger btn-sm btn-icon mr-1"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                   <button
                    v-if="
                      note.status == 'valide par doyen' &&
                      admin.role.nom == 'VPAA'
                    "
                    @click="refuse_note_modal(note)"
                    class="btn btn-outline-danger btn-sm btn-icon mr-1"
                  >
                    <i class="fa fa-times"></i>
                  </button> -->
                  <button
                    v-if="
                      note.status == 'valide par directeur' &&
                      admin.role.nom == 'DOYEN'
                    "
                    @click="valide_note_modal(note)"
                    class="btn btn-outline-success btn-sm btn-icon"
                  >
                    <i class="fa fa-check"></i>
                  </button>
                  <button
                    v-if="
                      note.status == 'valide par doyen' &&
                      admin.role.nom == 'VPAA'
                    "
                    @click="valide_note_modal(note)"
                    class="btn btn-outline-success btn-sm btn-icon"
                  >
                    <i class="fa fa-check"></i>
                  </button>
                  <button
                    v-if="note.status == 'en cours' && admin.role.nom == 'DE'"
                    @click="valide_note_modal(note)"
                    class="btn btn-outline-success btn-sm btn-icon"
                  >
                    <i class="fa fa-check"></i>
                  </button>
                  <!--  <button
                    v-if="note.status == 'valide par VPAA'"
                    @click="download_note(note)"
                    class="btn btn-outline-success btn-sm btn-icon"
                  >
                    <i class="fa fa-file-download"></i>
                  </button> -->
                  <button
                    @click="download_note(note)"
                    class="btn btn-outline-success btn-sm btn-icon"
                  >
                    <i class="fa fa-file-download"></i>
                  </button>
                </td>
              </tr>
              <tr v-show="!notes.length">
                <td colspan="17" class="text-center">Aucune NH trouvée.</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="16">
                  <jw-pagination
                    :items="allNotes"
                    @changePage="onChangePagenote"
                  ></jw-pagination>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="refuse_note_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="#refuse_note_modal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content p-5">
          <form action="" method="post">
            <div class="modal-header pb-3">
              <h5 class="modal-title" id="modal_enregistrer_header">
                Refus de la note honoraire
              </h5>
              <button
                type="button"
                class="btn btn-sm btn-icon btn-secondary btn-circle close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i aria-hidden="true" class="fas fa-times"></i>
              </button>
            </div>
            <div class="modal-body px-0 py-4 pb-8">
              <div class="row">
                <label
                  style="
                    color: rgb(17, 27, 131);
                    font-size: 16px;
                    font-weight: 700;
                  "
                  class="col-form-label col-3 text-lg"
                  >Motif<span style="color: #ee2d41">* </span> :</label
                >
              </div>
              <div class="d-flex justify-content-center">
                <textarea
                  v-model="justife"
                  rows="5"
                  class="form-control"
                ></textarea>
              </div>
            </div>
            <div class="d-flex justify-content-between modal-footer">
              <button
                type="button"
                class="btn bg-D38686 color-FFFFFF px-16 py-3"
                data-dismiss="modal"
                aria-label="Close"
              >
                ANNULER
              </button>
              <button
                :disabled="this.justife == null || this.justife == ''"
                @click="refuse_note()"
                type="button"
                class="btn btn-primary pl-10 pr-14 py-3"
              >
                <span
                  class="svg-icon svg-icon-white svg-icon-primary svg-icon-2x"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <polygon points="0 0 24 0 24 24 0 24" />
                      <path
                        d="M9.26193932,16.6476484 C8.90425297,17.0684559 8.27315905,17.1196257 7.85235158,16.7619393 C7.43154411,16.404253 7.38037434,15.773159 7.73806068,15.3523516 L16.2380607,5.35235158 C16.6013618,4.92493855 17.2451015,4.87991302 17.6643638,5.25259068 L22.1643638,9.25259068 C22.5771466,9.6195087 22.6143273,10.2515811 22.2474093,10.6643638 C21.8804913,11.0771466 21.2484189,11.1143273 20.8356362,10.7474093 L17.0997854,7.42665306 L9.26193932,16.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        opacity="0.3"
                        transform="translate(14.999995, 11.000002) rotate(-180.000000) translate(-14.999995, -11.000002) "
                      />
                      <path
                        d="M4.26193932,17.6476484 C3.90425297,18.0684559 3.27315905,18.1196257 2.85235158,17.7619393 C2.43154411,17.404253 2.38037434,16.773159 2.73806068,16.3523516 L11.2380607,6.35235158 C11.6013618,5.92493855 12.2451015,5.87991302 12.6643638,6.25259068 L17.1643638,10.2525907 C17.5771466,10.6195087 17.6143273,11.2515811 17.2474093,11.6643638 C16.8804913,12.0771466 16.2484189,12.1143273 15.8356362,11.7474093 L12.0997854,8.42665306 L4.26193932,17.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        transform="translate(9.999995, 12.000002) rotate(-180.000000) translate(-9.999995, -12.000002) "
                      />
                    </g>
                  </svg>
                </span>
                Refuser
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="valide_note_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="#Validenote"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content p-5">
          <form action="" method="post">
            <div class="modal-header pb-3">
              <h5
                v-if="admin.role.nom == 'VPAA'"
                class="modal-title"
                id="modal_enregistrer_header"
              >
                Approbation de la note honoraire
              </h5>
              <h5 v-else class="modal-title" id="modal_enregistrer_header">
                Validation de la note honoraire
              </h5>

              <button
                type="button"
                class="btn btn-sm btn-icon btn-secondary btn-circle close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i aria-hidden="true" class="fas fa-times"></i>
              </button>
            </div>
            <div class="modal-body">
              <table class="table">
                <thead style="background-color: #003667; color: white">
                  <tr class="text-center">
                    <th>Plafonnement HS FI</th>
                    <th>Plafonnement HS FC</th>
                    <th>Total HS plafonné</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="text-center">
                    <td>{{ note.heures_supp_fi }} H</td>
                    <td>{{ note.heures_supp_fc }} H</td>
                    <td>{{ note.heures_supp_total }} H</td>
                  </tr>
                  <tr class="text-center">
                    <td style="background-color: #dae9f7">
                      <strong> Montant FI</strong>
                    </td>
                    <td style="background-color: #dae9f7">
                      <strong>Montant FC</strong>
                    </td>
                    <td style="background-color: #dae9f7">
                      <strong>Montant total</strong>
                    </td>
                  </tr>
                  <tr class="text-center">
                    <td style="background-color: #dae9f7">
                      <strong>{{ note.montant_total_fi }} DH</strong>
                    </td>
                    <td style="background-color: #dae9f7">
                      <strong>{{ note.montant_total_fc }} DH</strong>
                    </td>
                    <td style="background-color: #dae9f7">
                      <strong>{{ note.montant_total }} DH</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-flex justify-content-between modal-footer">
              <button
                type="button"
                class="btn bg-danger color-FFFFFF px-16 py-3"
                data-dismiss="modal"
                aria-label="Close"
              >
                ANNULER
              </button>
              <button
                @click="valide_note()"
                type="button"
                class="btn btn-primary pl-10 pr-14 py-3"
              >
                <span
                  class="svg-icon svg-icon-white svg-icon-primary svg-icon-2x"
                >
                  <span class="svg-icon svg-icon-success svg-icon-2x">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <polygon points="0 0 24 0 24 24 0 24" />
                        <path
                          d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "
                        />
                      </g>
                    </svg>
                  </span>
                </span>
                Valider
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VclTable } from "vue-content-loading";
import * as XLSX from "xlsx";
import moment from "moment";

export default {
  props: {
    admin: {},
  },
  components: {
    VclTable,
  },
  data() {
    return {
      allNotes: [],
      prof: [],
      notes: [],
      note: {},
      vacataire: [],
      professeur: {},
      profLoaded: null,
      NotesLoaded: null,
      keyword: null,
      search: null,
      nb_heures_old: null,
      nb_heures: null,
      type: "",
      commentaire: null,
      justife: null,
      profNotFound: false,
      disableValideBtn: false,
      selectedItems: [],
      currentDateTime: moment().format("YYYY-MM-DD"),
      filterEtape: "",
      filterEtab: "",

      config: {
        headers: {
          Authorization: "Bearer " + this.admin.api_token,
        },
      },
    };
  },
  watch: {
    search(after, before) {
      if (this.search != "") {
        this.searchNotes();
      } else {
        this.reloadnotes();
      }
    },
  },

  methods: {
    hasPermission(code) {
      return this.admin.permissions.some(
        (permission) => permission.code === code
      );
    },
    filtrer() {
      axios
        .post(
          "/api/filter/notes",
          {
            admin_id: this.admin.id,
            etape: this.filterEtape,
            etablissement_id: this.filterEtab,
          },
          this.config
        )
        .then((res) => {
          this.allNotes = res.data;
          this.NotesLoaded = 1;
        });
    },

    getResults() {
      axios
        .get("/api/search/prof/" + this.keyword, this.config)
        .then((res) => {
          this.professeur = res.data;

          if (Object.keys(this.professeur).length === 0) {
            this.profNotFound = true;
            this.disableValideBtn = true;
          } else {
            this.profNotFound = false;
            this.disableValideBtn = false;
          }
        })
        .catch((error) => {
          let message = "Erreur";
          if (error.response && error.response.data.message) {
            message = error.response.data.message;
          }

          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 20000,
            title: message,
            icon: "error",
            confirmButtonText: "Cool",
          });
        });
    },

    onChangePagenote(notes) {
      // update page of items
      this.notes = notes;
    },
    downloadNhAll() {
      window.location.href = "/administration/permanent/nh/export";
    },

    download_note(note) {
      window.location.href = "/administration/permanent/nh/download/" + note.id;
    },
    reloadnotes() {
      axios
        .get("/api/get/notes/permanent/" + this.admin.id, this.config)
        .then((res) => {
          this.allNotes = res.data;
          this.notes = res.data;
          this.NotesLoaded = 1;
        });
    },

    searchNotes() {
      axios
        .get(
          "/api/search/notes/" + this.admin.id + "/" + this.search,
          this.config
        )
        .then((res) => (this.notes = res.data))
        .catch((error) => {});
    },

    valide_note_modal(note) {
      this.note = note;
      this.professeur = note.vacataire;
      $("#valide_note_modal").modal("show");
    },

    valide_note() {
      axios
        .put(
          "/api/note/valide/" + this.note.id + "/" + this.admin.id,
          {},
          this.config
        )
        .then((response) => {
          $("#valide_note_modal").modal("hide");
          this.note = {};
          this.reloadnotes();

          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            title: "Note honoraire validée",
            icon: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    refuse_note_modal(note) {
      this.note = note;
      $("#refuse_note_modal").modal("show");
    },

    refuse_note() {
      axios
        .put(
          "/api/note/refuse/" + this.note.id + "/" + this.admin.id,
          {
            justife: this.justife,
          },
          this.config
        )
        .then((response) => {
          $("#refuse_note_modal").modal("hide");
          this.note = {};
          this.reloadnotes();

          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            title: "Note honoraire refusée",
            icon: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  beforeMount() {
    axios
      .get("/api/get/notes/permanent/" + this.admin.id, this.config)
      .then((res) => {
        this.allNotes = res.data;
        this.NotesLoaded = 1;
      });
  },
};
</script>
